<svg
  *ngIf="!isImage"
  [ngClass]="['icon', size, iconStyle, status, inherit ? 'currentcolor' : '']"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
>
  <use *ngIf="type !== 'doutone'" [attr.xlink:href]="svgPath()"></use>

  <use *ngIf="type === 'doutone'" class="opacity-doutone" [attr.xlink:href]="svgPath('solid')"></use>
  <use *ngIf="type === 'doutone'" [attr.xlink:href]="svgPath('line')"></use>
</svg>

<img *ngIf="isImage" [src]="name" alt="" />
